import { db, functions, auth } from '@/firebase/config'
import { collection, query, where, orderBy, getDocs, doc, setDoc } from 'firebase/firestore'
import { httpsCallable } from "firebase/functions";

const updateAlertsReadAll = async (pId) => {
    const docsToMarkRead = [];

    // Collection reference
    const collectionRef = query(
        collection(db, 'alerts'),
        where("userId", "==", auth.currentUser.uid),
        where("to", "==", pId),
        where("read", "==", false)
    );

    const querySnapshot = await getDocs(collectionRef);

    const markReadPromises = querySnapshot.docs.map(async (unread) => {
        try {
            const markRead = httpsCallable(functions, 'documentUpdates-setDocument');
            await markRead({
                collection: "alerts",
                id: unread.id,
                merge: true,
                fields: { read: true }
            });
        } catch (error) {
            console.error(`Error updating alerts to read in cloud function documentUpdates-setDocument`, error);
        }
    });

    // Wait for all promises to resolve
    await Promise.all(markReadPromises);

    // Additional code can be added here if needed

    return;
};

export default updateAlertsReadAll;

